import { RollingNumber } from './RollingNumber';
import { NUMBER_PATTERN } from './utils';

interface RollingTextProps {
    text: string;
}

export function RollingText({ text }: RollingTextProps) {
    return (
        <>
            {text
                .split(NUMBER_PATTERN)
                .map((segment, index) =>
                    index % 2 === 1 ? (
                        <RollingNumber key={index} value={segment} />
                    ) : (
                        <span key={index}>{segment}</span>
                    ),
                )}
        </>
    );
}
